import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import QAInformation from './QAInformation';
import { useState } from 'react';
import Review from './Review';
import clsx from 'clsx';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Button } from '@material-ui/core';
import axios from 'axios';
import { appUrl } from '../../../../../utils/config';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: '#F9F9FC',
  },
  titleGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    backgroundColor: '#F5F9FF',
  },
  head: {
    textAlign: 'center',
  },
  closeBtn: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '12px',
    right: '10px',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
      color: '#FF0000',
    },
  },
  stepIcon: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E0E0E0',
    color: '#fff',
  },
  active: {
    backgroundColor: '#EC6535', // orange when active
  },
  completed: {
    backgroundColor: '#4CAF50', // green when completed
  },
  number: {
    color: '#fff',
    fontWeight: '550',
  },
  stepConnector: {
    '& $line': {
      borderColor: '#E0E0E0',
    },
  },
  completedStepConnector: {
    '& $line': {
      borderColor: '#4CAF50',
    },
  },
  line: {
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const steps = ['Enter Inspection Details', 'Review & Submit Details'];

const CustomStepIcon = (props) => {
  const classes = useStyles();
  const { active, completed, icon } = props;

  return (
    <div
      className={clsx(classes.stepIcon, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      <Typography className={classes.number}>{icon}</Typography>
    </div>
  );
};

const AddQADetails = ({
  openDialog,
  closeViewScreen,
  POLineRecordDetails,
  row,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(true);
  const [poDetails, setPoDetails] = useState({});
  const [qaInfoData, setQaInfoData] = useState({});
  const [OtherInfoTempNumber, setOtherInfoTempNumber] = useState(0);
  // const [COAFiles, setCOAFILES] = React.useState([]);
  const [errors, setErrors] = useState({
    analyticalReportNumber: '',
    qaQuantityFields: '',
    cmoQADate: '',
    errorTitle: '',
    coaFile: '',
  });
  const classes = useStyles();

  const handleNext = () => {
    // setCompleted((prevCompleted) => ({
    //   ...prevCompleted,
    //   [activeStep]: true,
    // }));
    // if (activeStep === 0) {
    //   // setSponsorDetailsLoading(true);
    // }
    if (handleValidation(qaInfoData)) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleCancel = () => {
    closeViewScreen();
  };

  useEffect(() => {
    const data = {
      supplierPurchaseOrderNumber:
        POLineRecordDetails.supplierPurchaseOrderNumber,
      materialCode: POLineRecordDetails.materialCode,
      schrockenSupplierPOBatchID: row.schrockenSupplierPOBatchID,
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchGRNLineDetails`,
        data
      )
      .then((res) => {
        setPoDetails(res.data.data.PODetails);
        setQaInfoData({
          ...res.data.data.PODetails.GRDetails.qualityAssuranceInfo,
          samplingMaterialNumberQA:
            String(res.data.data.PODetails.POLineRecordDetails.materialCode) ||
            '',
          samplingQuantityQA:
            res.data.data.PODetails.GRDetails.qualityAssuranceInfo
              .samplingQuantityQA || 0.0,
          passedQtyQA:
            res.data.data?.PODetails?.GRDetails?.receivedQuantityInfo
              ?.actualQuantityReceived || 0.0,
          rejectedQuantityQA: 0.0,
          cmoQADate:
            res.data.data?.PODetails?.GRDetails?.qualityAssuranceInfo
              ?.cmoQADate || '',
          reasonForRejection: '',
          otherInformation: '',
          // cmoAnalyticalReportNumber: '',
          analyticalReportNumber:
            res.data.data.PODetails.GRDetails.qualityAssuranceInfo
              .samplingQuantityQA || '',
        });
        // setCOAFILES()
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (activeStep === 0) {
      setErrors({
        analyticalReportNumber: '',
        qaQuantityFields: '',
        cmoQADate: '',
        errorTitle: '',
        coaFile: '',
      });
    }
  }, [qaInfoData]);

  const handlingDeleteFile = (i) => {
    // for rec fromBE=> mfd as 1, for local filter out
    //check for filetype in file
    //if 'buffer' then follow filter logic
    // if it is not buffer edit that file data sayn mfd 1
    if (qaInfoData.COAFiles[i].grFileType === 'buffer') {
      let newdel = qaInfoData.COAFiles.filter(
        (file) => file.grFileName !== qaInfoData.COAFiles[i].grFileName
      );
      setQaInfoData((previousData) => ({ ...previousData, COAFiles: newdel }));
      // setCOAFILES(newdel);
    } else {
      // COAFiles[i].markForDelete=1;
      let markDelFile = qaInfoData.COAFiles.map((file) =>
        file.grFileHash === qaInfoData.COAFiles[i].grFileHash
          ? { ...file, markForDelete: true }
          : file
      );
      setQaInfoData((previousData) => ({
        ...previousData,
        COAFiles: markDelFile,
      }));
      // setCOAFILES(markDelFile);
    }
  };

  const fileHandling = (files, Type) => {
    files.forEach((file) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        // Do whatever you want with the file contents
        const newArr = {
          grFileData: reader.result,
          grFileName: file.name,
          grFileType: 'buffer',
          schrockenGRFileId: '',
          grFileHash: '',
          markForDelete: false,
        };

        // setCOAFILES([...COAFiles, newArr]);
        setQaInfoData((previousData) => ({
          ...previousData,
          COAFiles: [...previousData.COAFiles, newArr],
        }));
        // handlingFiles(newArr, 'COAFiles');
      };
    });
  };

  const handleChange = (e, name) => {
    if (name === 'otherInformation') {
      let { value } = e.target;

      setQaInfoData((previousData) => ({
        ...previousData,
        otherInformation: value,
      }));
    }
  };

  const handlingFiles = (file, name) => {
    if (name === 'COAFiles') {
      setQaInfoData((previousData) => ({
        ...previousData,
        COAFiles: [...previousData.COAFiles, file],
      }));
    }
    if (name === 'otherFiles') {
      setQaInfoData((previousData) => ({
        ...previousData,
        otherFiles: previousData?.otherFiles
          ? [...previousData.otherFiles, file]
          : [file],
      }));
    }
  };

  const handlingDeleteFileType = (i, name) => {
    if (name === 'COAFiles') {
      if (qaInfoData.COAFiles[i].grFileType === 'buffer') {
        let newdel = qaInfoData.COAFiles.filter(
          (file) => file.grFileName !== qaInfoData.COAFiles[i].grFileName
        );
        // this.setState({
        //   qualityAssuranceInfo: {
        //     ...this.state.qualityAssuranceInfo,
        //     COAFiles: newdel,
        //     deletePrompt: false,
        //   },
        // });
        setQaInfoData((previousData) => ({
          ...previousData,
          COAFiles: newdel,
        }));
      }
    }

    //invoice files deleting in Parent File
    if (name === 'otherFiles') {
      if (qaInfoData.otherFiles[i].grFileType === 'buffer') {
        let newdel = qaInfoData.otherFiles.filter(
          (file) => file.grFileName !== qaInfoData.otherFiles[i].grFileName
        );
        setQaInfoData((previousData) => ({
          ...previousData,
          otherFiles: newdel,
          deletePrompt: false,
        }));
      }
    }
  };

  const handleTempNumber = (name) => {
    if (name === 'OtherInfoTempNumber') {
      setOtherInfoTempNumber(OtherInfoTempNumber + 1);
    }
  };

  const handleValidation = (data) => {
    let valid = true;
    // if (
    //   qaInfoData.samplingQuantityQA &&
    //   parseFloat(qaInfoData.samplingQuantityQA) === 0
    // ) {
    //   valid = false;
    //   setErrors((previousData) => ({
    //     ...previousData,
    //     samplingQuantityQA: 'Enter QA Sampling Quantity',
    //   }));
    // }
    // if (
    //   qaInfoData.passedQtyQA &&
    //   parseFloat(qaInfoData.passedQtyQA) === 0
    // ) {
    //   valid = false;
    //   setErrors((previousData) => ({
    //     ...previousData,
    //     passedQtyQA: 'Enter QA Passes Quantity',
    //   }));
    // }
    // if (
    //   qaInfoData.rejectedQuantityQA &&
    //   parseFloat(qaInfoData.rejectedQuantityQA) === 0
    // ) {
    //   valid = false;
    //   setErrors((previousData) => ({
    //     ...previousData,
    //     passedQtyQA: 'Enter QA Rejected Quantity',
    //   }));
    // }

    if (!data.analyticalReportNumber) {
      valid = false;
      setErrors((previousData) => ({
        ...previousData,
        analyticalReportNumber: 'Enter Analytical Report Number.',
        errorTitle: 'Enter the Analytical Report Number.',
      }));
      return valid;
    }

    if (!data.cmoQADate) {
      valid = false;
      setErrors((previousData) => ({
        ...previousData,
        cmoQADate: 'Enter CMO QA Date.',
        errorTitle: 'Enter the QA Date.',
      }));
      return valid;
    }

    const isEqual3Decimals = (a, b) =>
      Math.round(a * 1000) === Math.round(b * 1000);
    let sum =
      parseFloat(data.samplingQuantityQA) +
      parseFloat(data.passedQtyQA) +
      parseFloat(data.rejectedQuantityQA);
    if (
      !isEqual3Decimals(
        sum,
        parseFloat(
          poDetails.GRDetails.receivedQuantityInfo.actualQuantityReceived
        )
      )
    ) {
      valid = false;
      setErrors((previousData) => ({
        ...previousData,
        qaQuantityFields: 'Enter correct quantity.',
        errorTitle:
          'Quantity discrepancy detected. The sum of the sampled, passed, and rejected quantity must equal the total quantity. Please revise the quantities and try again.',
      }));
      return valid;
    }

    // if (Array.isArray(data.COAFiles) && data.COAFiles.length < 1) {
    //   valid = false;
    //   setErrors((previousData) => ({
    //     ...previousData,
    //     coaFile: 'Upload CoA file.',
    //     errorTitle: 'Missing CoA file.',
    //   }));
    //   return valid;
    // }

    setErrors((previousData) => ({
      ...previousData,
      analyticalReportNumber: '',
      coaFile: '',
      errorTitle: '',
      cmoQADate: '',
      qaQuantityFields: '',
    }));

    return valid;
  };

  return (
    <>
      <Dialog open={openDialog} fullScreen>
        <DialogTitle style={{ padding: '0px' }}>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                <Typography variant='h6' style={{ fontSize: '1.875rem' }}>
                  {/* Add QA Details */}
                  Add Inspection Details
                </Typography>
                <Typography>
                  Raw Material (RM) / Packaging Material (PM) Record
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant='body2'
                className={classes.closeBtn}
                onClick={handleCancel}
              >
                Cancel{' '}
                <CloseIcon style={{ fontSize: '35px', color: '#FF0000' }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ paddingBottom: '2rem' }}>
          <Grid container justifyContent='center'>
            <Grid item xs={12} md={10}>
              <Stepper
                alternativeLabel
                nonLinear
                activeStep={activeStep}
                connector={
                  <StepConnector
                    classes={{
                      active: classes.stepConnector,
                      completed: classes.completedStepConnector,
                      line: classes.line,
                    }}
                  />
                }
              >
                {steps.map((label, index) => (
                  <Step key={label}>
                    <StepLabel
                      StepIconComponent={(props) => (
                        <CustomStepIcon
                          {...props}
                          completed={activeStep > index}
                          icon={index + 1}
                        />
                      )}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
              {activeStep === 0 &&
                (!loading ? (
                  <QAInformation
                    status={
                      poDetails.GRDetails.POBatchRecordDetails.batchStatusID
                    }
                    poDetails={poDetails}
                    onSave={handleNext}
                    qaInfoData={qaInfoData}
                    setQaInfoData={setQaInfoData}
                    COAFiles={qaInfoData?.COAFiles ? qaInfoData?.COAFiles : []}
                    handlingDeleteFile={handlingDeleteFile}
                    fileHandling={fileHandling}
                    handleChange={handleChange}
                    parentHandlingDeleteFile={handlingDeleteFileType}
                    OtherInfoTempNumber={OtherInfoTempNumber}
                    handleTempNumber={handleTempNumber}
                    handlingFiles={handlingFiles}
                    errors={errors}
                  />
                ) : (
                  <Grid container justify='center'>
                    <div
                      style={{
                        textAlign: 'center',
                        marginTop: '15%',
                        minWidth: '60vw',
                      }}
                    >
                      <CircularProgress color='primary' thickness={7} />
                    </div>
                  </Grid>
                ))}
              {activeStep === 1 && (
                <Review
                  status={
                    poDetails.GRDetails.POBatchRecordDetails.batchStatusID
                  }
                  poDetails={poDetails}
                  qaInfoData={qaInfoData}
                  onClose={handleCancel}
                  COAFiles={qaInfoData?.COAFiles ? qaInfoData?.COAFiles : []}
                  fileHandling={fileHandling}
                  handlingDeleteFile={handlingDeleteFile}
                  tempNumber={OtherInfoTempNumber}
                  handleValidation={handleValidation}
                  errors={errors}
                  setErrors={setErrors}
                />
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddQADetails;
